import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite linear forwards;
  
  /* Apply border-radius from parent if needed, or pass via props */
  border-radius: inherit;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${({ $isLoaded }) => ($isLoaded ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
`;

const ResponsiveImage = ({ src, alt, className, style, objectFit = 'cover' }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <ImageWrapper className={className} style={style}>
      <StyledImage
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        $isLoaded={isLoaded}
        onLoad={() => setIsLoaded(true)}
        style={{ objectFit }}
      />
    </ImageWrapper>
  );
};

export default ResponsiveImage;
